<template>
    <v-container fluid fill-height class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
            <v-card class="ma-0 pa-0 desktop">
                <v-col class="ma-0 pa-0">
                    <v-row class="ma-0 pa-0">
                        <v-col cols="2">Importo totale preventivi: </v-col>
                        <v-col cols="2" class="totale">€ {{ totale.totaleImportoPreventiviStr }}</v-col>
                        <v-spacer />
                    </v-row>
                    <v-row class="ma-0 pa-0">
                        <v-col cols="2">Importo totale ore: </v-col>
                        <v-col cols="2" class="totale">€ {{ totale.totaleImportoOreTotStr }}</v-col>
                        <v-spacer />
                    </v-row>
                </v-col>
            </v-card>

            <v-card class="ma-0 pa-0 mobile">
                <v-col class="ma-0 pa-0">
                    <v-row class="ma-0 pa-0">
                        <v-col cols="6" class="pl-1 pr-0">Importo totale preventivi: </v-col>
                        <v-col cols="6" class="totale pr-0">€ {{ totale.totaleImportoPreventiviStr }}</v-col>

                    </v-row>
                    <v-divider class="ma-0 pa-0" />
                    <v-row class="ma-0 pa-0">
                        <v-col cols="6" class="pl-1 pr-0">Importo totale ore: </v-col>
                        <v-col cols="6" class="totale pr-0">€ {{ totale.totaleImportoOreTotStr }}</v-col>
                        <v-spacer />
                    </v-row>
                </v-col>
            </v-card>

            <v-data-table :items="elencoDati" :headers="headersDati" :items-per-page="999" dense
                no-data-text="Nessun preventivo o totale ore da fatturare" hide-default-footer :mobile-breakpoint="0"
                style="width: 100%;" :height="altezzaTabella" fixed-header class="mt-1">
                <template v-slot:item="{ item }">
                    <tr :class="raggruppaClienti ? 'isClickable' : ''"
                        @click="raggruppaClienti ? $emit('dettaglioCliente', item) : ''"
                        @contextmenu.prevent="apriMenu($event, item)">
                        <td v-if="!raggruppaClienti">{{ $functions.getWeekDay(item.dataFormat).substring(0, 3) + ' ' +
                            item.data }}</td>
                        <td class="text-xs-right">{{ item.operatore }}</td>
                        <td class="text-xs-right">{{ item.cliente }}</td>
                        <td class="text-xs-right">{{ item.descrizione }}</td>
                        <td class="text-xs-right">{{ item.destinazione }}</td>
                        <td class="text-xs-right">{{ item.totaleOre }}</td>
                        <td class="text-xs-right" v-if="!raggruppaClienti">{{ item.tipoImporto }}</td>
                        <td class="text-xs-right" v-if="!raggruppaClienti">{{ item.importo }}</td>
                        <td class="text-xs-right">{{ item.importoTotale }}</td>
                    </tr>
                </template>
            </v-data-table>

            <!-- MENU CONTESTUALE -->
            <v-menu v-model="menuAperto" :position-x="menuX" :position-y="menuY" offset-y absolute>
                <v-list dense>
                    <v-list-item @click="confermaFattura(itemSelezionato)">
                        <v-list-item-title>Conferma emissione fattura</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

        </v-col>
    </v-container>
</template>

<script>
import mixinr from "./mixinRiepilogo.js";
import { prepara_fattura } from "@/api/api.documenti.js";

export default {
    name: "TabellaRiepilogo",
    mixins: [mixinr],

    props: {
        raggruppaClienti: { type: Boolean, default: false },
        elencoDati: { type: Array, default: () => [] },
        totale: { type: Object, default: () => { } },
        altezzaTabella: { type: String, default: "auto" },
        separaOperatori: { type: Boolean, default: false }
    },

    data: () => ({
        headersDati: [],
        menuAperto: false,
        menuX: 0,
        menuY: 0,
        itemSelezionato: null
    }),


    methods: {
        apriMenu(event, item) {
            if (item.tipoImporto != "Preventivo") return;
            this.itemSelezionato = item;
            this.menuX = event.clientX;
            this.menuY = event.clientY;
            this.menuAperto = true;
        },

        async confermaFattura(item) {
            this.menuAperto = false;
            console.log("Conferma fattura per:", item);

            let par = {
                Stato: 2,
                NrDocu: item.nrDocu,
            }
            let res = await prepara_fattura(par)
            if (res.data != "OK") this.$toast.alert(res.data);
            else
                this.$toast.success("Fattura confermata");
        },

    },

    mounted() {
        this.headersDati = this.getHeadersTabellaPrev();
    },

    watch: {
        raggruppaClienti() {
            if (this.raggruppaClienti) {
                this.headersDati = this.getHeadersTabellaRaggruppa();
            } else {
                this.headersDati = this.getHeadersTabellaPrev();
            }
        },
    }
}
</script>